module.exports = __webpack_public_path__ + "img/404.3d401507.png";